import { FormControlLabel, FormGroup, FormLabel, MenuItem, Radio, Select, Stack, TextField } from "@mui/material"
import { CountryData, CountyData, TemplateData } from "../../../types";
import { useEffect, useRef, useState } from "react";
import { useAPI } from "../../../hooks/useAPI";

interface DemoGraphicsBoxProps {
  template: TemplateData;
  setTemplate: (val: TemplateData) => void;
  countries: CountryData[];
}

export const DemoGraphicsBox = ( { template, setTemplate, countries }: DemoGraphicsBoxProps ) => {
  const [counties, setCounties] = useState<CountyData[]>([]);
  const { fetchData } = useAPI();
  const isLoading = useRef(false);

  useEffect(() => {
    if (template.demographic?.country_id && !isLoading.current) {
      fetchData(`/counties/${template.demographic?.country_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setCounties(data);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [template.demographic?.country_id]);

  console.log(counties);

  return (
    <Stack spacing={2}>
      <FormGroup>
        <Stack direction="row" spacing={2}>
          <FormControlLabel
            label="Man"
            control={
              <Radio 
                checked={template?.demographic?.gender == 'male'} 
                onChange={(e: any) => setTemplate({ ...template, demographic: { ...template.demographic ?? {}, gender: e.target.checked ? 'male' : 'woman' } })}
              />
            }
          />
          <FormControlLabel
            label="Woman"
            control={
              <Radio
                checked={template.demographic?.gender == 'woman'} 
                onChange={(e: any) => setTemplate({ ...template, demographic: { ...template.demographic ?? {}, gender: e.target.checked ? 'woman' : 'male' } })}
              />
            }
          />
        </Stack>
      </FormGroup>
      <FormGroup>
        <Stack direction="row" spacing={2}>
          <Stack>
            <FormLabel>Age From</FormLabel>
            <Select 
              value={template.demographic?.age_from} 
              sx={{ width: '160px' }}
              onChange={(e: any) => setTemplate({ ...template, demographic: { ...template.demographic ?? {}, age_from: e.target.value } })}
            >
              {Array.from({ length: 100 }, (_, i) => (
                <MenuItem key={i + 1} value={i + 1}>
                  {i + 1}
                </MenuItem>
              ))}
            </Select>
          </Stack>
          <Stack>
            <FormLabel>Age To</FormLabel>
            <Select 
              value={template.demographic?.age_to} 
              sx={{ width: '160px' }}
              onChange={(e: any) => setTemplate({ ...template, demographic: { ...template.demographic ?? {}, age_to: e.target.value } })}
            >
              {Array.from({ length: 100 }, (_, i) => (
                <MenuItem key={i + 1} value={i + 1}>
                  {i + 1}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </Stack>
      </FormGroup>
      <FormGroup>
        <FormLabel>Country</FormLabel>
        <Select
          sx={{ width: '340px' }}
          value={template.demographic?.country_id} 
          onChange={(e: any) => setTemplate({ ...template, demographic: { ...template.demographic ?? {}, country_id: e.target.value } })}
        >
          {
            countries.map((country, index) => (
              <MenuItem key={index} value={country.id}>{country.name}</MenuItem>
            ))
          }
        </Select>
      </FormGroup>
      <FormGroup>
        <FormLabel>Geo Targeting</FormLabel>
        <Select
          sx={{ width: '100%' }}
          value={Array.isArray(template.demographic?.geo_targeting) ? template.demographic?.geo_targeting : []} 
          multiple
          onChange={(e: any) => setTemplate({ ...template, demographic: { ...template.demographic ?? {}, geo_targeting: e.target.value } })}
        >
          {
            counties.map((county, index) => (
              <MenuItem key={index} value={county.name}>{county.state} / {county.name}</MenuItem>
            ))
          }
        </Select>
      </FormGroup>
    </Stack>
  )
}